<template>
  <div class="pt-2">
    <div >
      <div class="d-flex  justify-space-between">
        <h3>{{ $t('autoHedge.dealOrderFlow.title') }}</h3>
        <base-button
          @click="togglePaused"
          style="background: #ffbf00; padding: 0.3rem 0.9rem; color: black"
          >{{ isPaused ? $t('autoHedge.dealOrderFlow.resume') : $t('autoHedge.dealOrderFlow.pause') }}</base-button
        >
      </div>

      <v-text-field v-model="searchQuote" :label="$t('autoHedge.dealOrderFlow.searchQuoteId')"></v-text-field>
    </div>

    <v-card outlined class="table-wrapper elevation-0">
      <div class="table-body">
        <base-data-table
          class="py-3"
          :headers="headers"
          :items="searchTrades"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:item.side="{ item }">
            <span
              :style="{ color: item.side === 'BUY' ? '#ff4444' : '#00ff88' }"
            >
              {{ item.side }}
            </span>
          </template>

            <template v-slot:item.price="{ item }">
            <span
              :style="{ color: 'white'}"
            >
             <b>{{ item.price }}</b>
            </span>
          </template>
        </base-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { useCoreStore } from '@/store/coreStore';
import { mapStores } from 'pinia';
export default {
  data() {
    return {
      searchQuote:"",
      isPaused:false,
    //  paused: false,
      currentExposureUSD: -2.4,
      totalDealValue: 0,
      totalDealVolume: 0,

      totalAskDealValue: 0,
      totalAskDealVolume: 0,

      totalBidDealValue: 0,
      totalBidDealVolume: 0,
      localMarketPrice: this.currentMarketPrice,
      localAverageDealPrice: this.averageDealPrice,
      localMarketPriceBid: this.currentMarketPriceBid,
      localMarketPriceAsk: this.currentMarketPriceAsk,
      localAverageDealPriceAsk: this.averageDealPriceAsk,
      localAverageDealPriceBid: this.averageDealPriceBid,
      trades: [],
    };
  },
  props: [
    "currentMarketPriceAsk",
    "currentMarketPriceBid",
    "averageDealPriceBid",
    "averageDealPriceAsk",
    "currentMarketPrice",
    "averageDealPrice",
  ],
  mounted() {
    setInterval(() => {
      this.addNewDeal();
    }, 5000);
  },
    computed:{
      ...mapStores(useCoreStore),
    headers(){
      return [
        { text: this.$t('autoHedge.dealOrderFlow.headers.time'), value: "time" },
        { text: this.$t('quoteInfo.side'), value: "side" },
        { text: this.$t('autoHedge.dealOrderFlow.headers.size'), value: "size" },
        { text: this.$t('autoHedge.dealOrderFlow.headers.price'), value: "price" },
        { text: this.$t('autoHedge.dealOrderFlow.headers.client'), value: "counterparty" },
        { text: this.$t('autoHedge.dealOrderFlow.headers.sprd'), value: "risk" },
        { text: this.$t('autoHedge.dealOrderFlow.headers.quoteId'), value: "ticket" },
      ];
    },
    searchTrades(){
    if (!this.searchQuote) return this.trades;
    
    return this.trades.filter(trade => trade.ticket.toLowerCase().includes(this.searchQuote.toLowerCase()))
    }
  },
  methods: {
    togglePaused() {
      this.isPaused=!this.isPaused;
      //this.paused = !this.paused;
      this.coreStore.savePauseDealOrderFlow(this.isPaused)
    },
    addNewDeal() {
      if (this.coreStore.getPauseDealOrderFlow) return;

      const sides = ["BUY", "SELL"];
      const clients = [
        "CORP-TREAS-F",
        "HEDGE-FUND-G",
        "PENSION-H",
        "BANK-PROP-I",
        "ASSET-MGR-J",
        "INSURANCE-K",
      ];
      const side = sides[Math.floor(Math.random() * sides.length)];
      const sizeValue = Math.random() * 5 + 0.5;
      const size = sizeValue.toFixed(1) + "M";
      const client = clients[Math.floor(Math.random() * clients.length)];
      const spread = (Math.random() * 2 + 0.5).toFixed(1);
      const quoteId = "QT-" + (89404 + Math.floor(Math.random() * 100));

      const now = new Date();
      const timeStr = now.toTimeString().slice(0, 8);

      // Generate realistic deal price based on bid/ask and side
      let dealPrice;
      if (side === "BUY") {
        // When buying, we pay the ask price (plus small variance)
        dealPrice = this.localMarketPriceAsk + (Math.random() - 0.5) * 0.002; // ±1 pip variance around ask
      } else {
        // When selling, we receive the bid price (plus small variance)
        dealPrice = this.localMarketPriceBid + (Math.random() - 0.5) * 0.002; // ±1 pip variance around bid
      }

      this.trades.unshift({
        time: timeStr,
        side: side,
        size: size,
        price: dealPrice.toFixed(4),
        counterparty: client,
        risk: spread,
        ticket: quoteId,
      });

      // Update net exposure based on deal
      if (side === "BUY") {
        this.currentExposureUSD += sizeValue;
      } else {
        this.currentExposureUSD -= sizeValue;
      }

      // Update average deal price calculation
      this.totalDealValue += sizeValue * dealPrice;
      this.totalDealVolume += sizeValue;
      this.localAverageDealPrice = this.totalDealValue / this.totalDealVolume;

      // Update bid/ask specific averages
      if (side === "BUY") {
        this.totalAskDealValue += sizeValue * dealPrice;
        this.totalAskDealVolume += sizeValue;
        this.localAverageDealPriceAsk =
          this.totalAskDealVolume > 0
            ? this.totalAskDealValue / this.totalAskDealVolume
            : localAverageDealPriceAsk;
      } else {
        this.totalBidDealValue += sizeValue * dealPrice;
        this.totalBidDealVolume += sizeValue;
        this.localAverageDealPriceBid =
          this.totalBidDealVolume > 0
            ? this.totalBidDealValue / this.totalBidDealVolume
            : this.localAverageDealPriceBid;
      }

      const marketMovement = (Math.random() - 0.5) * 0.005; // ±2.5 pips movement
      this.localMarketPrice += marketMovement;

      const spreadValue = 0.0004; // 4 pips spread
      this.localMarketPriceBid = this.localMarketPrice - spreadValue / 2;
      this.localMarketPriceAsk = this.localMarketPrice + spreadValue / 2;
    },
  },

};
</script>
<style scoped>
.table-wrapper {
  position: relative;
  max-height: 375px;
  display: flex;
  flex-direction: column;
}
.table-body {
  flex: 1;
  overflow-y: auto;
}

.table-xscroll > div {
  width: 1200px;
  height: 1px;
}


</style>
